export default "__VITE_ASSET__f0222a12__"